import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Number$isFinite from "@babel/runtime-corejs3/core-js/number/is-finite";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent, onMounted, computed, reactive, ref, onUnmounted } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import MortgageCalculatorsToolbar from "./mortgage-calculators-toolbar.vue";
import ReportTabLayout from "@Broker/@Modules/clients/reports/reports-containers/report-tab-layout.vue";
import SectionError from "@Shared/components/sections/section-error.vue";
import MortgageDetailsMixin from "@Broker/@Modules/clients/applications/application/select-options/mortgage-details-mixin";
import { MORTGAGE_FREQUENCY, MORTGAGE_COMPOUNDING_PERIOD, MORTGAGE_TYPE } from "@Shared/@Types/application/application-enums";
import { CalcBean, copyFrom, formatMoney, formatRate, formatTerm } from "./scenario-calcs";
import userSbScenarioList from "./userSb-scenario-list.vue";
import userSbScenarioAnalyzer from "./userSb-scenario-analyzer.vue";
import userSbScenarioComparison from "./userSb-scenario-comparison.vue";
import { capitalize } from "@Shared/@Utils/helpers/text";
import i18n from "@Shared/i18n";
import Err from "@Broker/@Routes/error";
import { showToast } from "@Shared/@Utils/constants";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import * as ApplicationActions from "@Broker/@Modules/clients/applications/application/store/application-actions";
import * as ApplicationMutations from "@Broker/@Modules/clients/applications/application/store/application-mutations";
import { useApplicationStoreActions, useApplicationStoreGetters, useApplicationStoreMutations as useApplicationStoreSetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
export const componentName = "ScenarioBuilderContainer";
export default defineComponent({
  name: componentName,
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    MortgageCalculatorsToolbar,
    userSbScenarioList,
    userSbScenarioAnalyzer,
    userSbScenarioComparison,
    SectionError,
    ReportTabLayout
  }),
  mixins: [MortgageDetailsMixin],
  props: {
    initData: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    var _props$initData2;
    const {
      CURRENT_APPLICATION,
      CALCULATED_VALUES_BY_MORTGAGE_TYPE,
      GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE,
      CURRENT_APPLICATION_ID
    } = useApplicationStoreGetters([ApplicationGetters.CURRENT_APPLICATION, ApplicationGetters.CALCULATED_VALUES_BY_MORTGAGE_TYPE, ApplicationGetters.GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE, ApplicationGetters.CURRENT_APPLICATION_ID]);
    const {
      SAVE_CURRENT_APPLICATION
    } = useApplicationStoreActions([ApplicationActions.SAVE_CURRENT_APPLICATION]);
    const {
      RESET_SUBMISSION_INFORMATION
    } = useApplicationStoreSetters([ApplicationMutations.RESET_MORTGAGE_INFORMATION, ApplicationMutations.RESET_SUBMISSION_INFORMATION]);
    const isEmbedded = computed(() => {
      var _props$initData;
      return Boolean((_props$initData = props.initData) == null ? void 0 : _props$initData.mortgageType);
    });
    const getNumericValue = (value, fallback) => {
      const parsedValue = Number(value);
      return _Number$isFinite(parsedValue) ? parsedValue : fallback;
    };
    const formatMoneyDisplay = val => {
      return val && val > 0 ? formatMoneyValueLong(val) : "-";
    };
    const mortgageInfo = reactive({
      totalLoanAmount: 0,
      monthlyPayment: 0,
      interestRate: "0.000",
      frequencyPayment: 0,
      paymentFrequencyLabel: "-",
      termDisplay: "-",
      amortizationDisplay: "-",
      compoundingPeriodLabel: "-"
    });
    const selectedMortgageType = ref(((_props$initData2 = props.initData) == null ? void 0 : _props$initData2.mortgageType) || MORTGAGE_TYPE.FIRST);
    const getSubmissionDetailsForType = mortgageType => {
      const submissionRecord = GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE.value(mortgageType);
      return (submissionRecord == null ? void 0 : submissionRecord["submission-details"]) || {};
    };
    const availableMortgageTypes = computed(() => {
      var _props$initData$ineli, _props$initData3;
      const currentApplication = CURRENT_APPLICATION.value;
      const submissions = currentApplication["submission-details"] || [];
      const presentTypes = _mapInstanceProperty(submissions).call(submissions, sub => {
        var _sub$submissionDetai;
        return sub == null ? void 0 : (_sub$submissionDetai = sub["submission-details"]) == null ? void 0 : _sub$submissionDetai["mortgage-type"];
      });
      const ineligible = (_props$initData$ineli = (_props$initData3 = props.initData) == null ? void 0 : _props$initData3.ineligibleMortgageTypes) != null ? _props$initData$ineli : [];
      const types = [MORTGAGE_TYPE.FIRST, MORTGAGE_TYPE.SECOND, MORTGAGE_TYPE.THIRD];
      return _mapInstanceProperty(types).call(types, type => ({
        value: type,
        label: i18n.t("application-form." + type).toString(),
        available: _includesInstanceProperty(presentTypes).call(presentTypes, type) && !_includesInstanceProperty(ineligible).call(ineligible, type)
      }));
    });
    const populateMortgageInfo = (refreshAfterSet = false) => {
      var _props$initData4;
      const isInitialType = selectedMortgageType.value === ((_props$initData4 = props.initData) == null ? void 0 : _props$initData4.mortgageType);
      let interestRate;
      let termTotalMonths;
      let amortTotalMonths;
      let frequency;
      let compounding;
      let totalLoanAmount;
      const initData = props.initData;
      if (isInitialType && initData && !refreshAfterSet) {
        interestRate = getNumericValue(initData.interestRate, 0);
        termTotalMonths = getNumericValue(initData.mortgageTerm, 0);
        amortTotalMonths = getNumericValue(initData.amortizPeriodMths, 0);
        frequency = initData.frequency || MORTGAGE_FREQUENCY.MONTHLY;
        compounding = initData.compoundedPeriod || MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY;
        totalLoanAmount = getNumericValue(initData.totalLoanAmount, 0);
      } else {
        const sd = getSubmissionDetailsForType(selectedMortgageType.value);
        const calculatedValues = CALCULATED_VALUES_BY_MORTGAGE_TYPE.value(selectedMortgageType.value);
        interestRate = getNumericValue(sd["interest-rate"], 0);
        termTotalMonths = getNumericValue(sd["term-years"], 0) * 12 + getNumericValue(sd["term-months"], 0);
        amortTotalMonths = getNumericValue(sd["amortization-years"], 0) * 12 + getNumericValue(sd["amortization-months"], 0);
        frequency = sd.frequency || MORTGAGE_FREQUENCY.MONTHLY;
        compounding = sd["compounded-period"] || MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY;
        totalLoanAmount = getNumericValue(calculatedValues == null ? void 0 : calculatedValues.totalLoanAmount, 0);
      }
      const cbTemp = CalcBean();
      let monthlyPayment = 0;
      let frequencyPayment = 0;
      if (interestRate > 0 && amortTotalMonths > 0 && totalLoanAmount > 0) {
        monthlyPayment = cbTemp.calcFrequencyPayment(interestRate, MORTGAGE_FREQUENCY.MONTHLY, totalLoanAmount, compounding, amortTotalMonths);
        frequencyPayment = cbTemp.calcFrequencyPayment(interestRate, frequency, totalLoanAmount, compounding, amortTotalMonths);
      }
      mortgageInfo.totalLoanAmount = totalLoanAmount;
      mortgageInfo.monthlyPayment = monthlyPayment;
      mortgageInfo.interestRate = interestRate.toFixed(3);
      mortgageInfo.frequencyPayment = frequencyPayment;
      mortgageInfo.paymentFrequencyLabel = frequency ? i18n.t("application-form." + frequency).toString() : "-";
      mortgageInfo.termDisplay = formatTerm(termTotalMonths);
      mortgageInfo.amortizationDisplay = formatTerm(amortTotalMonths);
      mortgageInfo.compoundingPeriodLabel = compounding ? i18n.t("application-form." + compounding).toString() : "-";
    };
    const populateInputsFromApplication = (refreshAfterSet = false) => {
      var _props$initData5;
      const isInitialType = selectedMortgageType.value === ((_props$initData5 = props.initData) == null ? void 0 : _props$initData5.mortgageType);
      let interestRate;
      let frequency;
      let amortTotalMonths;
      let actualPaymentTerm;
      let compoundedPeriod;
      let totalLoanAmount;
      const initData = props.initData;
      if (isInitialType && initData && !refreshAfterSet) {
        totalLoanAmount = getNumericValue(initData.totalLoanAmount, 0);
        interestRate = getNumericValue(initData.interestRate, 0.001);
        actualPaymentTerm = getNumericValue(initData.mortgageTerm, 0);
        amortTotalMonths = getNumericValue(initData.amortizPeriodMths, 0);
        compoundedPeriod = initData.compoundedPeriod || MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY;
        frequency = initData.frequency;
      } else {
        const sd = getSubmissionDetailsForType(selectedMortgageType.value);
        const calculatedValues = CALCULATED_VALUES_BY_MORTGAGE_TYPE.value(selectedMortgageType.value);
        totalLoanAmount = getNumericValue(calculatedValues == null ? void 0 : calculatedValues.totalLoanAmount, 0);
        interestRate = getNumericValue(sd["interest-rate"], 0.001);
        actualPaymentTerm = getNumericValue(sd["term-years"], 0) * 12 + getNumericValue(sd["term-months"], 0);
        amortTotalMonths = getNumericValue(sd["amortization-years"], 0) * 12 + getNumericValue(sd["amortization-months"], 0);
        compoundedPeriod = sd["compounded-period"] || MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY;
        frequency = sd.frequency;
      }
      editedms.netRate = interestRate > 0 ? interestRate : editedms.netRate;
      editedms.paymentFrequencyDd = frequency || editedms.paymentFrequencyDd;
      editedms.amortizationTerm = amortTotalMonths || editedms.amortizationTerm;
      editedms.actualPaymentTerm = actualPaymentTerm || editedms.actualPaymentTerm;
      editedms.interestCompoundDd = compoundedPeriod;
      editedms.totalLoanAmount = totalLoanAmount > 0 ? totalLoanAmount : editedms.totalLoanAmount;
    };
    const onMortgageTypeChange = (refreshAfterSet = false) => {
      populateMortgageInfo(refreshAfterSet);
      populateInputsFromApplication(refreshAfterSet);
    };
    const calcBean = reactive(CalcBean());
    const calcTypeOptions = [{
      value: "P",
      label: i18n.t("financial-tools.payment")
    }, {
      value: "A",
      label: i18n.t("financial-tools.amortization")
    }];
    let showScen = true;
    let bean = reactive(calcBean.newMortgageScenariosBean());
    const editedms = bean.editedMortgageScenario;
    const errorMessageAmt = computed(() => {
      if (editedms.totalLoanAmount < 10000 || editedms.totalLoanAmount > 100000000) {
        $("[name='mortgageAmount']").trigger("focus");
        return i18n.t("financial-tools.message_missing_question_1");
      } else return "";
    });
    const errorMessageRate = computed(() => {
      if (editedms.netRate < 0.001 || editedms.netRate > 100.0) {
        $("[name='netRate']").trigger("focus");
        return i18n.t("financial-tools.message_missing_question_2");
      } else return "";
    });
    const errorMessagePayTerm = computed(() => {
      if (editedms.actualPaymentTerm < 1 || editedms.actualPaymentTerm > 35 * 12) {
        $("[name='actualPaymentTerm']").trigger("focus");
        return i18n.t("financial-tools.message_missing_question_3").toString();
      } else return "";
    });
    const errorMessageAmortPer = computed(() => {
      if (editedms.calcTypeFlag == "P" && (editedms.amortizationTerm < 1 || editedms.amortizationTerm > 35 * 12)) {
        $("[name='amortizationTerm']").trigger("focus");
        return i18n.t("financial-tools.message_missing_question_3").toString();
      } else return "";
    });
    const errorMessagePandI = computed(() => {
      if (editedms.calcTypeFlag == "A" && (editedms.pAndIPaymentAmountMonthly < 1 || editedms.pAndIPaymentAmountMonthly > 1000000)) {
        $("[name='pAndIPaymentAmountMonthly']").trigger("focus");
        return i18n.t("financial-tools.message_missing_questionRange") + formatMoney(1) + ", " + formatMoney(1000000) + "]";
      } else return "";
    });
    const erMsgs = {
      errorMessageAmt,
      errorMessageRate,
      errorMessagePayTerm,
      errorMessageAmortPer,
      errorMessagePandI
    };
    function formatVal(val) {
      return val && val > 0 ? val.toLocaleString(this.$root.$i18n.locale, {}) : "-";
    }
    function populateGeneratedScenarios() {
      const generatedMStemp = calcBean.newMortgageScenarios();
      const generatedMS = [];
      generatedMStemp.netRate = bean.editedMortgageScenario.netRate;
      generatedMStemp.totalLoanAmount = bean.editedMortgageScenario.totalLoanAmount;
      generatedMStemp.actualPaymentTerm = bean.editedMortgageScenario.actualPaymentTerm;
      generatedMStemp.interestCompoundDd = bean.editedMortgageScenario.interestCompoundDd;
      generatedMStemp.calcTypeFlag = bean.editedMortgageScenario.calcTypeFlag;
      if (generatedMStemp.calcTypeFlag == "P") generatedMStemp.amortizationTerm = bean.editedMortgageScenario.amortizationTerm;
      let msind = 0;
      let assumedAmortization = 0;
      for (const mtgfreq in MORTGAGE_FREQUENCY) {
        generatedMStemp.pAndIPaymentAmountMonthly = bean.editedMortgageScenario.pAndIPaymentAmountMonthly;
        assumedAmortization = calcBean.calculateValuesOnMS(bean, generatedMStemp, MORTGAGE_FREQUENCY[mtgfreq], assumedAmortization);
        generatedMS[msind++] = copyFrom(calcBean.newMortgageScenarios(), generatedMStemp);
      }
      copyFrom(bean.calcMortgageScenario, bean.editedMortgageScenario);
      for (let msi = 0; msi < generatedMS.length; msi++) copyFrom(bean.generatedMS[msi], generatedMS[msi]);
      return false;
    }
    function generateScenarios() {
      for (const erm in erMsgs) if (erMsgs[erm].value != "") {
        alert(i18n.t("financial-tools.allMustBePopulated") + ": " + erMsgs[erm].value);
        return;
      }
      if (editedms.calcTypeFlag == "A") {
        const fpm = calcBean.calcFrequencyPayment(editedms.netRate, MORTGAGE_FREQUENCY.MONTHLY, editedms.totalLoanAmount, editedms.interestCompoundDd, bean.assumedMaxAmortization * 12);
        if (fpm > editedms.pAndIPaymentAmountMonthly) {
          bean.maxMortYears = bean.assumedMaxAmortization;
          bean.userMortAmount = editedms.totalLoanAmount;
          bean.userPayment = editedms.pAndIPaymentAmountMonthly;
          bean.calcMinPayment = fpm;
          showToast("error", i18n.t("financial-tools.sc_amortErra") + bean.maxMortYears.toString() + i18n.t("financial-tools.sc_amortErrb") + formatMoneyValueLong(bean.userMortAmount) + i18n.t("financial-tools.sc_amortErrc") + formatMoneyValueLong(bean.userPayment) + i18n.t("financial-tools.sc_amortErrd") + formatMoneyValueLong(bean.calcMinPayment) + ".");
          $("[name='pAndIPaymentAmountMonthly']").trigger("focus");
          if (bean.calcMortgageScenario.calcTypeFlag == "") bean.generatedMS[0].calcTypeFlag = "";
          return;
        }
      }
      try {
        populateGeneratedScenarios();
        return;
      } catch (e) {
        Err.handle("populateGeneratedScenarios::" + e);
      }
      const userMessage = editedms.calcTypeFlag == "A" ? "sc_amortErrInput" : "sc_payErrInput";
      showToast("error", userMessage);
      bean.maxMortYears = -1;
      if (bean.calcMortgageScenario.calcTypeFlag == "") bean.generatedMS[0].calcTypeFlag = "";
    }
    function handleClearSelection() {
      editedms.totalLoanAmount = 0;
      editedms.calcTypeFlag = "P";
      editedms.netRate = 0.001;
      editedms.actualPaymentTerm = 5 * 12;
      editedms.amortizationTerm = 25 * 12;
      editedms.pAndIPaymentAmountMonthly = 0;
    }
    async function setScenarioAsMortgage(selectedScenario) {
      var _props$initData6, _context;
      const currentApplication = CURRENT_APPLICATION.value;
      const submissionDetails = currentApplication["submission-details"];
      const submissionIndex = _findIndexInstanceProperty(submissionDetails).call(submissionDetails, submission => {
        var _submission$submissio;
        return ((_submission$submissio = submission["submission-details"]) == null ? void 0 : _submission$submissio["mortgage-type"]) === selectedMortgageType.value;
      });
      if (submissionIndex < 0) {
        console.warn("Cannot find submission details for mortgage type:", selectedMortgageType.value);
        return;
      }
      const sd = submissionDetails[submissionIndex];
      const termYears = Math.floor(selectedScenario.actualPaymentTerm / 12).toString();
      const termMonths = (selectedScenario.actualPaymentTerm % 12).toString();
      const amortizationYears = Math.floor(selectedScenario.amortizationTerm / 12).toString();
      const amortizationMonths = (selectedScenario.amortizationTerm % 12).toString();
      const submissionStructure = _objectSpread(_objectSpread({}, sd), {}, {
        "submission-details": _objectSpread(_objectSpread({}, sd["submission-details"]), {}, {
          "interest-rate": String(selectedScenario.netRate),
          frequency: selectedScenario.paymentFrequencyDd,
          "term-years": termYears,
          "term-months": termMonths,
          "amortization-years": amortizationYears,
          "amortization-months": amortizationMonths
        })
      });
      RESET_SUBMISSION_INFORMATION({
        index: submissionIndex,
        structure: submissionStructure
      });
      const applicationId = CURRENT_APPLICATION_ID.value;
      const clientUsername = (_props$initData6 = props.initData) == null ? void 0 : _props$initData6.clientUsername;
      if (!applicationId || !clientUsername) {
        console.warn("Cannot save application after setting scenario as mortgage. Missing applicationId or clientUsername.", {
          applicationId,
          clientUsername
        });
        return;
      }
      await SAVE_CURRENT_APPLICATION({
        applicationId,
        clientUsername,
        reFetchCalculations: true
      });
      onMortgageTypeChange(true);
      bean.generatedMS[0].calcTypeFlag = "";
      _spliceInstanceProperty(_context = bean.savedScenariosList).call(_context, 0);
    }
    handleClearSelection();
    if (isEmbedded.value) {
      onMortgageTypeChange();
    } else {
      const thisComponentCookieString = localStorage.getItem(componentName);
      if (thisComponentCookieString) {
        try {
          const thisComponentCookieData = JSON.parse(thisComponentCookieString);
          _Object$assign(mortgageInfo, thisComponentCookieData);
        } catch (e) {
          console.error("Error parsing localStorage data for " + componentName + ":", e);
          localStorage.removeItem(componentName);
        }
      }
    }
    onMounted(() => {
      $("[name='mortgageAmount']").trigger("focus");
    });
    onUnmounted(() => {
      if (!isEmbedded.value) localStorage.setItem(componentName, _JSON$stringify(mortgageInfo));
    });
    return {
      showScen,
      bean,
      editedms,
      erMsgs,
      calcTypeOptions,
      capitalize,
      formatMoney,
      formatRate,
      formatVal,
      formatTerm,
      generateScenarios,
      handleClearSelection,
      setScenarioAsMortgage,
      isEmbedded,
      mortgageInfo,
      selectedMortgageType,
      availableMortgageTypes,
      onMortgageTypeChange,
      formatMoneyDisplay
    };
  }
});